export const formatErrorConstructorName = (constructorName: string): string => {
  const errorNameMap: Record<string, string> = {
    ERROR: 'Unknown Error',
    'unknown error': 'Unknown Error',
    ArticlesNotFoundError: 'Articles Not Found',
    ArticleNotFoundError: 'Article Not Found',
    CategoriesNotFoundError: 'Categories Not Found',
    CategoryNotFoundError: 'Category Not Found',
    ValidationError: 'Validation Error',
    UpdateWidgetSessionValidationError: 'Widget Session Validation Error',
    AuthenticationError: 'Authentication Error',
    WixBusinessError: 'Business Error',

    TypeError: 'Type Error',
    ReferenceError: 'Reference Error',
    SyntaxError: 'Syntax Error',
    RangeError: 'Range Error',
    URIError: 'URI Error',
    EvalError: 'Eval Error',
    AggregateError: 'Aggregate Error',
    Error: 'Generic Error',

    NetworkError: 'Network Error',
    TimeoutError: 'Timeout Error',
    AbortError: 'Abort Error',
    FetchError: 'Fetch Error',

    NotFoundError: 'Not Found Error',
    BadRequestError: 'Bad Request Error',
    UnauthorizedError: 'Unauthorized Error',
    ForbiddenError: 'Forbidden Error',
    InternalServerError: 'Internal Server Error',
  };

  if (errorNameMap[constructorName]) {
    return errorNameMap[constructorName];
  }

  return constructorName
    .replace(/([A-Z])/g, ' $1')
    .replace(/^./, (str) => str.toUpperCase())
    .trim();
};
